import { useContext } from 'react';
import { appState } from '../providers';

const useAppState = () => {
  const context = useContext(appState);
  if (!context) {
    throw new Error('context not initialized');
  }
  return context;
};

export default useAppState;
